<template>
      <div id="compare">
            <section class="section compare-hero animate__animated animate__fadeIn">
                  <BackButton link="/plan-options" />
                  <div class="grid-container max">
                        <div class="compare-grid">
                              <div class="compare-left">
                                    <h1>Compare<br />your options</h1>
                                    <p class="compare-lead">Our HMO and HRA plans are designed to accommodate a range of financial and health goals.</p>
                                    <p class="compare-lead">Here&rsquo;s a high-level comparison to help you select the one that best fits you and your family.</p>
                              </div>
                              <div class="compare-right">
                                    <div v-for="(section, sIndex) in sections" :key="section.title" class="compare-section">
                                          <div v-if="sIndex === 0" class="compare-row compare-header-row">
                                                <h2 class="compare-section-title compare-section-title-header">{{ section.title }}</h2>
                                                <div class="compare-plan-label">HMO</div>
                                                <div class="compare-plan-label">HRA</div>
                                          </div>
                                          <h2 v-else class="compare-section-title">{{ section.title }}</h2>
                                          <div class="compare-row" v-for="row in section.rows" :key="row.label">
                                                <div class="compare-row-info">
                                                      <p class="compare-row-label">{{ row.label }}</p>
                                                      <p v-if="row.desc" class="compare-row-desc">{{ row.desc }}</p>
                                                </div>
                                                <div class="compare-check">
                                                      <svg v-if="row.hmo" width="36" height="36" viewBox="0 0 24 24"><path d="M9.172 18.657a1 1 0 0 1-.707-.293l-5.657-5.657a1 1 0 0 1 1.414-1.414l4.95 4.95L19.778 5.636a1 1 0 0 1 1.414 1.414L9.879 18.364a1 1 0 0 1-.707.293z" /></svg>
                                                </div>
                                                <div class="compare-check">
                                                      <svg v-if="row.hra" width="36" height="36" viewBox="0 0 24 24"><path d="M9.172 18.657a1 1 0 0 1-.707-.293l-5.657-5.657a1 1 0 0 1 1.414-1.414l4.95 4.95L19.778 5.636a1 1 0 0 1 1.414 1.414L9.879 18.364a1 1 0 0 1-.707.293z" /></svg>
                                                </div>
                                          </div>
                                    </div>
                              </div>
                        </div>
                        <p class="compare-footnote">1. Services must be properly coded as preventive care under the Patient Protection and Affordable Care Act. 2. Pharmacy is administered by SHBP&rsquo;s partner Express Scripts by Evernorth. 3. Completing your well-being incentive actions with Sharecare will earn you points. You can choose to redeem these points for well-being incentive credits to use on covered medical and pharmacy expenses or the Visa Prepaid Card option. Visit <a href="https://BeWellSHBP.com" target="_blank">BeWellSHBP.com</a> for more information.</p>
                  </div>
                  <div class="compare-btn-wrap">
                        <router-link to="/resources" class="compare-btn"><span>Next</span></router-link>
                  </div>
            </section>
      </div>
</template>

<script>
      import BackButton from "../components/BackButton"
      export default {
            name: "SHBPCompare",
            data() {
                  return {
                        sections: [
                              {
                                    title: "Paying for your care",
                                    rows: [
                                          { label: "Co-pays", desc: "A flat negotiated fee you pay at the point of service for certain covered medical and pharmacy services.", hmo: true, hra: false },
                                          { label: "Co-Insurance", desc: "The percentage you pay for the cost of covered health expenses after meeting your deductible.", hmo: true, hra: true },
                                          { label: "Deductible", desc: "The amount you’re responsible for paying each plan year before your plan begins to cover its portion of the covered cost.", hmo: true, hra: true },
                                          { label: "Preventive care at 100%¹", desc: "When provided by an in-network doctor, encouraging you to be proactive in your health", hmo: true, hra: true },
                                          { label: "Medical and pharmacy² costs count toward your out-of-pocket maximum", desc: "Expenses you pay for covered medical care—including prescriptions, co-pays (HMO only), co-insurance, and deductibles—apply to your out-of-pocket maximum", hmo: true, hra: true }
                                    ]
                              },
                              {
                                    title: "Access to providers",
                                    rows: [
                                          { label: "Access to Anthem’s expansive network of providers", desc: "Includes coverage in Georgia, nationally and internationally.", hmo: true, hra: true },
                                          { label: "See any provider you choose", desc: "Flexibility to see a provider in-network or out-of-network.", hmo: false, hra: true },
                                          { label: "No referrals necessary", desc: "Both plans are open-access, so no PCP referral is needed to see a specialist", hmo: true, hra: true },
                                          { label: "Access to LiveHealth Online", desc: "See a provider online 24/7", hmo: true, hra: true }
                                    ]
                              },
                              {
                                    title: "Incentive credits to help reduce your costs",
                                    rows: [
                                          { label: "Plan comes with starter credits contributed by SHBP", desc: "From 100 to 800 depending on the plan option and tier you select.", hmo: false, hra: true },
                                          { label: "Earn points", desc: "You can choose to redeem these points for well-being incentive credits to use on covered medical and pharmacy expenses³", hmo: true, hra: true },
                                          { label: "Roll over unused credits from 2026", desc: "", hmo: true, hra: true }
                                    ]
                              }
                        ]
                  }
            },
            mounted() {
                  window.scrollTo(0, 0)
            },
            components: {
                  BackButton
            }
      }
</script>

<style lang="scss">
#compare {
      .compare-hero {
            background-color: #ffffff;
            margin-top: 68px;
            padding: 120px 0 160px 0;
            position: relative;

            .back-btn {
                  left: 86px;
                  border-color: #1254E8;

                  &::before {
                        background-image: none;
                        background-color: #1254E8;
                        filter: none;
                        -webkit-mask-image: url("~@/assets/img/arrow-left-icon.png");
                        mask-image: url("~@/assets/img/arrow-left-icon.png");
                        -webkit-mask-size: 15px 13px;
                        mask-size: 15px 13px;
                        -webkit-mask-repeat: no-repeat;
                        mask-repeat: no-repeat;
                        -webkit-mask-position: center;
                        mask-position: center;
                  }
            }

            .grid-container.max {
                  width: 100%;
                  max-width: 85rem !important;
            }

            .compare-grid {
                  display: flex;
                  flex-wrap: nowrap;
                  align-items: flex-start;
                  justify-content: space-between;
                  gap: 64px;
                  margin-top: 48px;
            }

            .compare-left {
                  flex: 1 1 360px;
                  max-width: 480px;
                  position: sticky;
                  top: 140px;

                  h1 {
                        color: #1355E9;
                        font-size: clamp(2.75rem, 4.5vw, 4.25rem) !important;
                        font-weight: 600;
                        line-height: 1 !important;
                        margin-bottom: 24px;
                  }

                  .compare-lead {
                        color: #12130f;
                        font-size: 1.0625rem;
                        font-weight: 600;
                        line-height: 1.5;
                        margin-bottom: 16px;

                        &:last-child {
                              margin-bottom: 0;
                              font-weight: 500;
                        }
                  }
            }

            .compare-right {
                  flex: 2 1 640px;
                  max-width: 720px;
                  min-width: 0;

                  .compare-row {
                        display: grid;
                        grid-template-columns: 1fr 80px 80px;
                        align-items: center;
                        gap: 16px;
                  }

                  .compare-header-row {
                        border-bottom: none;
                  }

                  .compare-section-title-header {
                        margin: 0;
                        padding-bottom: 0;
                        border-bottom: none;
                  }

                  .compare-plan-label {
                        color: #1355E9;
                        font-weight: 700;
                        font-size: 1.125rem;
                        text-align: center;
                  }

                  .compare-section {
                        margin-bottom: 32px;

                        &:last-child {
                              margin-bottom: 0;
                        }
                  }

                  .compare-section-title {
                        color: #012E58;
                        font-weight: 600;
                        font-size: 1.375rem;
                        line-height: 1.3;
                        margin: 32px 0 12px 0;
                        padding-bottom: 12px;
                  }

                  .compare-row + .compare-row {
                        border-top: solid 1px #eef0f2;
                  }

                  .compare-row-info {
                        padding: 8px 0;
                  }

                  .compare-row-label {
                        color: #1355E9;
                        font-weight: 700;
                        font-size: 1rem;
                        margin-bottom: 0.5rem;
                  }

                  .compare-row-desc {
                        color: #3F3A4E;
                        font-size: 0.9375rem;
                        line-height: 1.5;
                        margin-bottom: 0;
                  }

                  .compare-check {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding: 20px 0;

                        svg {
                              fill: #0A2C4C;
                        }
                  }
            }

            .compare-footnote {
                  color: #6b6b6b;
                  font-size: 0.75rem;
                  line-height: 1.6;
                  margin-top: 48px;
                  margin-bottom: 0;

                  a {
                        color: #1355E9;
                        text-decoration: underline;
                  }
            }

            .compare-btn-wrap {
                  position: fixed;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  z-index: 3;
                  background-color: #ffffff;
                  box-shadow: 0px -3px 4px rgba(0, 0, 0, 0.10);
                  padding: 20px 0;
                  text-align: center;
            }

            .compare-btn {
                  display: block;
                  background-color: #1355E9;
                  color: #ffffff !important;
                  font-weight: 700;
                  text-transform: uppercase;
                  font-size: 1rem;
                  padding: 18px 0;
                  width: 100%;
                  max-width: 330px;
                  text-align: center;
                  border-radius: 30px;
                  border: none;
                  cursor: pointer;
                  margin: 0 auto;

                  &:hover {
                        background-color: #44B8F3;
                  }
            }

            @media only screen and (max-width: 959px) {
                  padding: 96px 24px 140px 24px;

                  .back-btn {
                        left: 2rem;
                  }

                  .compare-grid {
                        flex-direction: column;
                        gap: 32px;
                        margin-top: 32px;
                  }

                  .compare-left {
                        flex: 0 0 auto;
                        max-width: 100%;
                        position: static;

                        h1 {
                              font-size: clamp(2rem, 8vw, 3rem) !important;
                        }
                  }

                  .compare-right {
                        flex: 0 0 auto;
                        max-width: 100%;

                        .compare-row {
                              grid-template-columns: 1fr 60px 60px;
                              gap: 8px;
                        }

                        .compare-plan-label {
                              font-size: 1rem;
                        }

                        .compare-section-title {
                              font-size: 1.1875rem;
                        }
                  }
            }
      }
}
</style>
